import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";

import { AppContexts } from "../../providers";
import UIkit from "uikit";
import classnames from "classnames";

const wdFormat = "YYYY-MM-DD HH:mm:ss";

const requiredFields = ["first_name", "last_name", "email"];

const UserGroupAdd = () => {
  let [errors, setErrors] = useState([]);

  let {
    isNew,
    setIsNew,
  } = useContext(AppContexts.InboxContext);

  const convertUTCDateToLocalDate = (date) => {
    const newDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60 * 1000,
    ).toLocaleString();

    return moment(newDate).format("YYYY-MM-DD HH:mm:ss");
  };

  const handleInput = (key, e) => {
    if (errors.includes(key)) {
      setErrors(errors.filter((f) => f !== key));
    }

  };

  const handleUpdate = (e) => {
    e.preventDefault();

    let valid = true;

    let result = "";

    UIkit.modal("#team-add").hide();

    if (result == null) {
      UIkit.notification(isNew ? "Add Failed" : "Update Failed");
    } else {
      UIkit.notification(
        isNew ? "Added Successfully" : "Updated Successfully",
      );
    }
  };

  const errorClass = (key) => {
    return errors.includes(key) ? ["error"] : [];
  };

  return (
    <div
      id="team-add"
      className="uk-modal-full hms-modals uk-modal uk-open uk-dark"
      uk-offcanvas="flip: true; overlay: true"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            data-uk-close
          ></button>
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">{isNew ? "Add a" : "Edit"} User Group</h2>
          </div>
          <div className="uk-modal-body">
            <form
              className="uk-grid-small uk-margin-none-top"
              data-uk-grid
              onSubmit={handleUpdate}
            >
              <div className="uk-width-1-1 uk-grid uk-grid-margin uk-first-column">
                <div className="uk-width-1-2 uk-first-column">
                  <label className="uk-form-label">Group Name*</label>
                  <div className="uk-form-controls">
                    <input
                      className={["uk-input", ...errorClass("group_name")].join(
                        " ",
                      )}
                      type="text"
                      placeholder=""
                      onInput={(e) => handleInput("group_name", e)}
                    />
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1 uk-grid uk-grid-margin uk-first-column">
                <div className="uk-width-1-1 uk-first-column">
                  <label className="uk-form-label">Description</label>
                  <div className="uk-form-controls">
                    <input
                      className={["uk-input", ...errorClass("description")].join(
                        " ",
                      )}
                      type="text"
                      placeholder=""
                      onInput={(e) => handleInput("description", e)}
                    />
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1 uk-margin-top">
                <button className="uk-button hms-btn hms-red-btn" type="submit">
                  Save
                </button>
                <button
                  className="uk-button hms-btn uk-modal-close"
                  uk-toggle="target: #team-add"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGroupAdd;
